import { Box, Button } from '@dtx-company/design-system/src'
import { fireAnalyticsEvent } from '@dtx-company/inter-app/src/event-tracking/helpers/fireAnalyticsEvent'
import { motion } from 'framer-motion'
import { useScreenSizeBreakpoints } from '@app/common/src/hooks/useScreenSizeBreakpoints'
import { useUpsellModalContext, useUpsellModalDispatch } from './UpsellModalContextProvider'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import React from 'react'
import useTranslation from 'next-translate/useTranslation'

export type UpsellModalStepProps = {
  children?: React.ReactNode
  step: number
}

const BackButton = (): JSX.Element => {
  const dispatch = useUpsellModalDispatch()
  const { heapId } = useUpsellModalContext()
  const { t } = useTranslation('common')

  return (
    <Box
      sx={theme => ({
        position: 'absolute',
        left: theme.spacing(2.5),
        top: theme.spacing(2.5)
      })}
    >
      <Button
        onClick={() => {
          dispatch({ type: 'DECREMENT_STEP' })
          fireAnalyticsEvent(`${heapId || 'UpsellModal'}_BackButton_Clicked`)
        }}
        variant="text"
        startIcon={ArrowBackIcon}
      >
        {t('DialogActions.Back')}
      </Button>
    </Box>
  )
}

export const UpsellModalStep = ({ children, step }: UpsellModalStepProps): JSX.Element => {
  const { currentStep } = useUpsellModalContext()
  const { isMobile } = useScreenSizeBreakpoints()

  const isCurrentStep = currentStep === step

  return (
    <motion.div
      key={step}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        padding: isMobile ? '1.25rem' : 0,
        paddingTop: isMobile ? '1rem' : 0,
        visibility: isCurrentStep ? 'visible' : 'hidden',
        overflowY: 'auto',
        height: '100%',
        width: '100%'
      }}
      initial={{ opacity: 0 }}
      animate={{ x: (step - currentStep) * 100 + '%', opacity: isCurrentStep ? 1 : 0 }}
      transition={{
        x: { type: 'spring', stiffness: 300, damping: 30 },
        opacity: { duration: 0.2 }
      }}
    >
      {step > 1 && <BackButton />}
      {children}
    </motion.div>
  )
}
